import { render, staticRenderFns } from "./DeviceRejectedList.vue?vue&type=template&id=5638ff1e&scoped=true&"
import script from "./DeviceRejectedList.vue?vue&type=script&lang=js&"
export * from "./DeviceRejectedList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRejectedList.vue?vue&type=style&index=0&id=5638ff1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638ff1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VChip,VDataTable,VIcon,VListItem,VMenu})
